// Module
var code = "<div ui-view=\"navigationContainer\" class=\"csv-importer-navigation-container\"></div> <div ui-view=\"stepContainer\" class=\"csv-importer-step-container container\"></div> ";
// Exports
module.exports = code;